import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ImageCropperComponent, CropperSettings, ImageCropper } from 'ng2-img-cropper';

import { ModalService } from 'app/shared/modal/modal.service';
import { environment } from 'environments/environment';
import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';

@Component({
  selector: 'app-upload-imagem',
  templateUrl: './upload-imagem.component.html',
  styleUrls: ['./upload-imagem.component.scss'],
})
export class UploadImagemComponent implements OnInit {

  @Input() img: any = null;
  @Input() linkOnly = false;
  @Input() label = 'Selecionar imagem';
  @Input() inscricao:any = null;
  @Input() tipoDocumento: any = null;
  @Input() estado: boolean;
  @Output() selected: EventEmitter<any> = new EventEmitter();

  @ViewChild('cropper', undefined)
  cropper: ImageCropperComponent;

  dataImg: any;
  imgValid: boolean;
  cropperSettings: CropperSettings;
  filename: string = undefined;
  document: any;
  file: any;
  environment = environment;

  showDocVeraciInfo: boolean;

  constructor(private modalService: ModalService,
              private elementRef: ElementRef,
              private spinnerService: BlockingSpinnerService) { }

  ngOnInit() {
    this.dataImg = this.img || {};
    this.imgValid = false;
    this.initCropper();
    this.showDocVeraciInfo = environment.docmentoVeracidadeInfoMedic;
  }

  mostrarModalUploadImg(): void {
    this.imgValid = false;
    this.modalService.open(`uploadImagem-${this.inscricao}`);
    this.changeCanvasWidth();
  }

  changeCanvasWidth() {
    const cropperDom = this.elementRef.nativeElement.querySelector('img-cropper');

    const canvasDom = this.elementRef.nativeElement.querySelector('canvas');
    if (canvasDom.width !== cropperDom.offsetWidth) {
      //console.log(`canvas antes: ${canvasDom.width} x ${canvasDom.height}`);
      canvasDom.width = cropperDom.offsetWidth;
      canvasDom.height = cropperDom.offsetHeight;
      //console.log(`canvas depois: ${canvasDom.width} x ${canvasDom.height}`);

      this.cropper.reset();
      this.cropper.cropper = new ImageCropper(this.cropperSettings); this.cropper.cropper.prepare(this.cropper.cropcanvas.nativeElement);
    }
  }

  initCropper() {
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.canvasWidth = 550;
    this.cropperSettings.canvasHeight = 300;

    this.cropperSettings.cropperClass = 'cropper';
    this.cropperSettings.croppingClass = 'cropperLoaded';

    this.cropperSettings.width = 750;
    this.cropperSettings.height = 550;
    this.cropperSettings.minWidth = 30;
    this.cropperSettings.minHeight = 40;

    this.cropperSettings.rounded = false;
    this.cropperSettings.keepAspect = true;
    this.cropperSettings.noFileInput = true;
    this.cropperSettings.preserveSize = true;
    this.cropperSettings.compressRatio = 0.8;

    this.cropperSettings.cropperDrawSettings.strokeColor = 'rgba(255, 255, 255, 0.3)';
    this.cropperSettings.cropperDrawSettings.strokeWidth = 1;
    this.cropperSettings.cropperDrawSettings.dragIconStrokeWidth = 0;
    this.cropperSettings.cropperDrawSettings.dragIconStrokeColor = 'rgba(255, 255, 255, 0)';
    this.cropperSettings.cropperDrawSettings.dragIconFillColor = 'rgba(255, 255, 255, 0.3)';
  }

  calcFileSize() {
    //console.log(this.dataImg.image);

    if (this.dataImg.image) {
      const parcialMb = (4 * Math.ceil(this.dataImg.image.length / 3)) * 0.5624896334383812;
      return Math.ceil(parcialMb) / 1000000;
    }

    if(this.document){
      const parcialMb = (4 * Math.ceil(this.document.length / 3)) * 0.5624896334383812;
      return Math.ceil(parcialMb) / 1000000;
    }
    return;
  }

  isImgValid() {
    //console.log(this.calcFileSize());
    return this.filename && this.calcFileSize() <= 10;
  }

  isDocValid(){
    return this.document && this.isFilePdf() && this.calcFileSize() <= 10;
  }

  isFilePdf(){
    return this.file.type=="application/pdf";
  }

  fileChangeListener($event) {
    const image: any = new Image();
    const file: File = $event.target.files[0];
    //console.log($event);
    const myReader: FileReader = new FileReader();
    const that = this;
    that.spinnerService.show();
    myReader.onloadend = function (loadEvent: any) {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
      that.filename = file.name;
      that.spinnerService.close();
    };
    myReader.readAsDataURL(file);
  }

  documentChangeListenter($event){
    const image: any = new Document();
    const file: File = $event.target.files[0];
    const myReader: FileReader = new FileReader();
    const that = this;
    that.spinnerService.show();
    myReader.onloadend = function (loadEvent: any) {
      image.src = loadEvent.target.result;
      that.filename = file.name;
      that.document = myReader.result;
      that.file = file;
      that.spinnerService.close();
    };
    myReader.readAsDataURL(file);
  }

  confirmaCropImagem() {
    this.imgValid = true;
    this.img = this.dataImg;
    this.modalService.close(`uploadImagem-${this.inscricao}`);
    this.selected.emit(this.img);
  }

  confirmaDocumento(){
    this.modalService.close(`uploadImagem-${this.inscricao}`);
    //console.log(this.img);
    this.selected.emit(this.document);
  }

}
